module.exports = __webpack_public_path__ + "img/0231f477a097436695c0feba99773675.ce6e9b2b.jpg";